import {Card, CardContent, Container, Stack} from "@mui/material"
import React, {FC, ReactNode} from "react"

const UnauthLayout: FC<{children: ReactNode}> = ({children}) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="space-evenly"
      sx={{
        height: "100vh",
        background:
          "linear-gradient(45deg, #D49A39, #f7dc88)"
      }}
    >
      <Container maxWidth="xs">
        <Card>
          <CardContent sx={{maxHeight: "80vh", overflowY: "scroll"}}>
            {children}
          </CardContent>
        </Card>
      </Container>
    </Stack>
  )
}

export default UnauthLayout
